import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import RivisionsTable from "./revisionsTable";

const Table = ({ record }) => {
  const [statusOptions, setStatusOptions] = useState([]);
  const { allRevisionStatuses } = useSelector(
    (state) => state.revisionStatusReducer
  );

  useEffect(() => {
    let updatedStatuses = allRevisionStatuses.map((el) => {
      const { status_name, id } = el;
      return { value: id, label: status_name };
    });
    setStatusOptions(updatedStatuses);
  }, [allRevisionStatuses]);

  return (
    <RivisionsTable
      parentRecordID={record.id}
      statusOptions={statusOptions}
      doc_revisions={record.doc_revisions}
    />
  );
};

export default Table;
